import { render, staticRenderFns } from "./NotificationsUser.vue?vue&type=template&id=8074e9ba&scoped=true&"
import script from "./NotificationsUser.vue?vue&type=script&lang=js&"
export * from "./NotificationsUser.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsUser.vue?vue&type=style&index=0&id=8074e9ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8074e9ba",
  null
  
)

export default component.exports